import { useEffect, useContext } from 'react';

import { AppContext } from '../scripts/context'

export default function Privacy() {

    const {
    //GENERAL
        pageElementsRefs,
        setBodyHeight,
    //MENU
        handleMenu,
    //SCROLL
        setScrollbarOffset,
    //STYLE
        updateCss,
        mediaStyleState,
        privacyContainerContentStyleState,
    } = useContext(AppContext);

    document.title = "privacy - njb design®";

    function handleScroll() {

        handleMenu("scroll");

        setScrollbarOffset();

    };

    function handleScrollEnd() {

        handleMenu("scrollend");

    };

    function handleResize() {

        setBodyHeight();
        updateCss();

    };

    //useEffect on intial render
    useEffect(() => {

        setBodyHeight();
        updateCss();

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("scrollend", handleScrollEnd);
        window.addEventListener("resize", handleResize);

        return () => {

            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("scrollend", handleScrollEnd);
            window.removeEventListener("resize", handleResize);

        };
                                                                    // eslint-disable-next-line
    }, []);

    return (
        <main id="privacy">
            <img id="media" style={mediaStyleState} alt="njbdesign_xthrust_0.webp" src="/media/njbdesign_xthrust_0.webp"/>
            <div id="privacy_container_content" ref={pageElementsRefs.mainContainerContent} style={privacyContainerContentStyleState}>
                <div id="text_container">
                    <h1>PRIVACY</h1>
                    <h2>We are dedicated to guarantee the security of <span className="nw">your personal data</span></h2>
                    <p>The privacy policy is intended to give you an overview of what types of personal data are generated when using our online services, how the personal data is collected, transmitted, stored and evaluated by <span className="nw">njb design llc</span> and / or third-party providers, and what options are available to manage your personal data.</p>
                    <p>Personal data can include:</p>
                    <p id="bullet_point">• Personal details like name, address, email or phone number</p>
                    <p id="bullet_point">• Information about hardware, software, connection and settings</p>
                    <p id="bullet_point">• User accounts and linked in-game actions, scores and progress</p>
                    <p id="bullet_point">• Any messages sent via digital communication media</p>
                    <p>Don’t hesitate to contact <a href="mailto:privacy@njb.design">privacy@njb.design</a> if you have specific questions related to privacy.</p>
                    <h2>General</h2>
                    <p>It’s our goal to minimize the collection of personal data whenever possible. We only store personal data that is required by law or functionally necessary to provide comfortable and secure online services for everyone. Your personal data is stored on servers within the European Union and Switzerland. We are not analysing, profiling or tracking your behaviour on any of our websites and limit third-party technologies to the essentials. We do not share personal data with any third-party providers unless functionally inevitable. We make sure that online interactions follow secure protocols and encrypt the transmission of data from and to our webservers.</p>
                    <h2>Management</h2>
                    <p>You have the right to receive information about the origin, recipient, and purpose of your stored personal data free of charge. In accordance with the legal requirements, you have the right to access, request a copy of, rectify, erase or restrict processing of your personal data. Furthermore, you have the right to object, withdraw consent at any time or lodge a complaint with a supervisory authority.</p>
                    <h2>Use Cases</h2>
                    <h4>Visiting Websites</h4>
                    <p>When visiting websites, your requests are sent to webservers to provide the required content. In this process, your IP address and type of request, together with a timestamp, are temporarily stored in the server logs. Logs are cleared every two weeks and are used for technical purposes exclusively.</p>
                    <h4>Shopping</h4>
                    <p>When adding products to shopping carts, the contents are stored in the local storage of the application used to access the online services. Your cart data will remain in the local storage until the cache of the application is cleared, all contents are removed from the cart, or the order is completed. When completing orders, your order data and shipping destination are sent to a thrusted third-party provider for the payment process. After the payment has succeeded, your order data, email, name and address, together with a timestamp are transmitted to a webserver and stored in a secure database. Order data remains in the database and is used for administrative purposes exclusively. Your email is used to send order notifications, while name and address are used for shipping.</p>
                    <h4>Creating Accounts</h4>
                    <p>When creating user accounts, your username, email and password, together with a timestamp are transmitted to a webserver and stored in a secure database. Account data remains in the database and is used for security purposes exclusively. Your username and password are used to protect your account and to provide secure authentication, while email is used to send notifications on account creation or in the process of amending account details.</p>
                    <h4>Playing Games</h4>
                    <p>When playing games, your in-game actions, scores and progress, together with a timestamp are linked to your online user account. Game data that is relevant to restore and validate your scores and progress is transmitted to a game server and stored in a secure database. Game data remains in the database and is used to guarantee fair gameplay and to keep rankings and statistics up to date. In multiplayer games, the game server directly forwards some of your game data to other players in the game, to allow real-time interactions.</p>
                    <h4>Sending Messages</h4>
                    <p>When sending emails, your message, email address and attachments, together with a timestamp are transmitted to a mail server and stored securely. Mail data remains on the mail server until your case has been resolved and is archived on a server that is not exposed to the internet afterwards.</p>
                    <h2>Third Party Providers</h2>
                    <h4>PayPal</h4>
                    <p>When buying products, PayPal services are used to process payments. In this case PayPal's privacy policy and terms of service apply, which you can review under the following link:</p>
                    <p id="p_center"><a href="https://www.paypal.com/privacy">https://www.paypal.com/privacy</a></p>
                </div>
            </div>
        </main>
    );

};